import axios from "axios"
import {API_TEAMS} from "../constants/apiUrls"

export default async function getTeam(accessToken, idTeam) {
    return axios.get(`${API_TEAMS}/${idTeam}`, {headers: {Authorization: `Bearer ${accessToken}`}})
        .then((response) => {
            return {
                licence_package: response.data.team.licence_package,
                licence_types: response.data.team.licence,
                licence_start_date: response.data.team.licence_start_date,
                licence_end_date: response.data.team.licence_end_date,
            }
        })
        .catch ((error) => {
            console.error(`GET ${API_TEAMS}/${idTeam}`, error)
        })
}